// Autogenerated file
export const tokenProviderTypesEnum = {
    Phone: "Phone",
    Email: "Email",
    Authenticator: "Authenticator",
};
export const tokenProviderTypes = [
    { label: "Телефон", value: "Phone" },
    { label: "Email", value: "Email" },
    { label: "Google Authenticator", value: "Authenticator" },
];
